$(document).ready(function(){
  function sortCollectionTiles(selector) {
    document.querySelectorAll(selector).forEach(function(list) {
      [].slice.call(list.querySelectorAll('.all_addones')).sort(function(a, b) {
        var textA = a.getAttribute('data-itgalpha').toLowerCase();
        var textB = b.getAttribute('data-itgalpha').toLowerCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      }).forEach(function(el) {
        list.appendChild(el);
      });
    });
  }

  fetch('/cart.js').then(response => response.json()).then(data => {
    var cart_count = data.item_count;
    if (cart_count == "0"){
      localStorage.removeItem("gift_price");
      localStorage.removeItem("gift_code");
      localStorage.removeItem("gift_status"); 
      localStorage.removeItem("gift_status");
      localStorage.removeItem("total_price");
      localStorage.removeItem("gift_id");
    }
  });

    let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
      if (items){
      items.forEach(item => {
        item.addEventListener("mouseover", () => {
          item.setAttribute("open", true);
          item.querySelector("ul").addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
        item.addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      });

      });
      }

  $('.message-box.one-field textarea').val('');
  
    if (!document.querySelector('.itg-cart')) {
      localStorage.setItem('previousURL', window.location.href);
    }
      var previousUrl = localStorage.getItem('previousURL');
      $('#cart_continue').attr('href',previousUrl);
   
function changeAccessibility() {  
  if ($(document).find('.annnc_info').length) {  
    if ($(window).innerWidth() <= 1351) {   
      if (!$('.annnc_info').hasClass('slick-initialized')) {  
        $('.annnc_info').slick({  
          dots: false,  
          arrows: false,  
          infinite: false,  
          speed: 300,  
          slidesToShow: 4,  
          slidesToScroll: 4,  
          responsive: [  
            {  
              breakpoint: 1350,  
              settings: {  
                slidesToShow: 3,  
                slidesToScroll: 1,  
                speed: 500,  
                autoplay: true,  
                autoplaySpeed: 2000,  
                infinite: true,  
                arrows: false,  
                dots: false  
              }  
            },  
            {  
              breakpoint: 1250,  
              settings: {  
                slidesToShow: 2,  
                slidesToScroll: 1,  
                speed: 500,  
                autoplay: true,  
                autoplaySpeed: 2000,  
                infinite: true,  
                arrows: false,  
                dots: false  
              }  
            },  
            {  
              breakpoint: 700,  
              settings: {  
                slidesToShow: 1,  
                slidesToScroll: 1,  
                speed: 500,  
                autoplay: true,  
                autoplaySpeed: 2000  
              }  
            }  
          ]  
        });  
      }  
    } else {  
      if ($('.annnc_info').hasClass('slick-initialized')) {  
        $('.annnc_info').slick('unslick');  
      }  
    }  
  }  
}  
  
  changeAccessibility();  
  $(window).resize(function () {  
  changeAccessibility();  
  });


  $(document).on('click', '.custom_reorder img', function(){
    $(this).closest('.customer-order-address-main-wrapper').find('.identixweb_advance_reorder .reorder_icon').trigger('click');
  });
  
   // image with tab section
  $(document).on('click', '.itgv--tabHeading', function(){
    var dataId = $(this).attr('data-block');
    $(this).addClass('active').siblings().removeClass('active');
    $('.itgv--imageWithTab_tabDetails').each(function(){
      var dataBlock = $(this).attr('data-block-id');
      if(dataBlock == dataId){
        $(this).show();
      }else{
        $(this).hide();
      }
    });
  });

  if($(document).find('.itgv--imageWithTab__imgMain').length ){
    $('.itgv--imageWithTab__imgMain').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 2000,
      fade: true,
      cssEase: 'linear'
    });
  }
  // banner slider
  if($(document).find('.custom_bannner_head').length ){
    $('.custom_bannner_head').slick({
      dots: false,
      infinite: true,
      autoplay: true,
      speed: 300,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      arrow:true,
      prevArrow: '<button class="slide-arrow prev-arrow"><svg  class="Arrowleft arrow" width="10" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.8301 20.1523L0.830078 10.6523L10.8301 1.15234" stroke="#614141" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button class="slide-arrow next-arrow"><svg  class="ArrowRight arrow" width="10" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.17017 20.1523L11.1702 10.6523L1.17017 1.15234" stroke="#614141" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    });
  }
  
  $(document).on("click",".identixweb_advance_reorder img",function() {
    $('.prod_img').attr('src', '//prospecbio.myshopify.com/cdn/shop/t/44/assets/prospecbio_icon.png')
  });

  // faq
  $(document).on("click",".des_qt",function() {
    $(this).closest('.tab_qt_tb').find(".des_ans").slideToggle();
    $(this).closest('.tab_qt_tb').find(".itg_accordion_plus").toggleClass("minus");
    $(this).closest('.tab_qt_tb').find(".itg_accordion_minus").toggleClass("plus");
    var id=$(this).closest('.tab_qt_tb').attr("id"); 
    $(".tab_qt_tb").not("#"+id).find(".des_ans").slideUp();
    $(".tab_qt_tb").not("#"+id).find(".itg_accordion_plus").removeClass("minus");
    $(".tab_qt_tb").not("#"+id).find(".itg_accordion_minus").removeClass("plus");
  }); 

  // load more  
  if($(document).find('.products-on-page').length ){
      var num1 = parseInt($(".load-more-btn").attr("data-show")  || 25);
      var coll_index = 0;
      $(".products-on-page li").each(function () {
        coll_index++;
        if (coll_index <= num1) {
          $(this).addClass("active");
        }
      });
   }
    
  $(document).on("click",".load-more-btn",function() {
     var max_langth = $(".products-on-page li").length;
     $('.products-on-page li').removeClass('active');
     var num1 = parseInt($(".load-more-btn").attr("data-show"));
     var newnum = num1 + 25;
     $(this).attr("data-show", newnum);
      var coll_index = 0;
      $(".products-on-page li").each(function () {
        coll_index++;
        if (coll_index <= newnum) {
          $(this).addClass("active");
        }
      });
      if (max_langth < newnum) {
        $(".load-more-btn").css("display", "none");
      }
  });

  //menu click
  $(document).on("click",".ctm_menu-item",function() {
    event.preventDefault();
    $('body').addClass('block-ui');
    $('.ctm_mega_menu').addClass('opened');
  });

  // coll_list_menu_js
 
  $(document).find('.coll_list_menu_js .collecion_list_main:first-child').addClass("collection_active");
  $(document).find('.coll_list_menu_js li.collecion_link-list:first').addClass("link_active");
  var link_url = $('.coll_list_menu_js li.collecion_link-list:first').attr('data-link-url');
  $(document).find('.coll_list_menu_js').find('.mega_menu_top a').attr('href', link_url);
  
  // custom collection alpha..
  if($(document).find('.coll_list_js .collecion_list_main, .coll_list_menu_js .collecion_list_main').length ){
    sortCollectionTiles('.coll_list_js .collecion_list_main_inner, .coll_list_menu_js .collecion_list_main_inner');
  }
  
  // coll_list_menu_js
  $(document).on("click",".coll_list_menu_js li.collecion_link-list",function() {
    $(this).addClass("link_active").siblings().removeClass('link_active');
    var value_1 = $(this).attr('data-coll');
    var link_url = $(this).attr('data-link-url');
    $(this).closest('.coll_list_menu_js').find('.mega_menu_top a').attr('href', link_url);
    $('.coll_list_menu_js .collecion_list_main').each(function() {
      var value_2 = $(this).attr('collection-url');
      if( value_1 == value_2 ){
         $(this).addClass("collection_active");
        if($(document).find('.collection_active').length ){
            sortCollectionTiles('.coll_list_menu_js .collection_active .collecion_list_main_inner');
         }
      } 
      else{
        $(this).removeClass("collection_active"); 
        $(this).parents(".coll_list_menu_js .custom_collection_list_wrapper").find("custom_collection_list_head .collecion_link-list").removeClass("collection_active");
      }
    });
  });


  // maga menu
  $(document).on("click",".popup__close, .popup__close_pro",function() {
    $('body').removeClass('block-ui');
    $('.ctm_mega_menu').removeClass('opened');
     $(document).find(".menu_product_pop").removeClass('menu_product_open');
    $(document).find(".header_coll_prdct_item").html('');
  });

  $(document).on("click",".menu_pop_close",function() {
    $(document).find(".menu_product_pop").removeClass('menu_product_open');
    $(document).find(".header_coll_prdct_item").html('');
  });

  $(document).on("click",".menu_header_coll",function() {
     var collectioHandle = $(this).attr('data-coll');
     $(document).find(".custom_loader").addClass('loading');
      $.ajax({
      url: `/collections/${collectioHandle}`,
      method: "GET",
      dataType: "html",
    }).done(function (responseText) {
      $(document).find(".header_coll_prdct_item").html('');
       const responseHTML = new DOMParser().parseFromString(responseText,"text/html");
       var divcollectiondata = $(responseHTML).find(".collecion_list_product").prop("innerHTML");
        $(document).find(".header_coll_prdct_item").html(divcollectiondata);
        $(document).find(".menu_product_pop").addClass('menu_product_open');
        $(document).find(".product-samples-button").html('');
          $(document).find('.menu_product_pop .coll_prdct_item li.dataColl').each(function() {
            var vari_id = $(this).find("option:selected").attr("data-value");
            $(this).closest(".coll_prdct").find(".add-to-cart-button").val(vari_id);
            var pro_id = $(this).find("option:selected").attr("data-product1");
            var pro_handle = $(this).find("option:selected").attr("data-handle1");
          });
        $(document).find(".custom_loader").removeClass('loading');
        
    }).fail(function (jqXHR, textStatus, errorThrown) {
    });
  });

  $('.coll_list_js .collecion_list_main:first-child').addClass("collection_active");
  $('.coll_list_js li.collecion_link-list:first').addClass("link_active");
  var linkUrl = $('.coll_list_js li.collecion_link-list:first').attr('data-link-url');
  $('.coll_list_js').find('.custom_collection_list_top a').attr('href', linkUrl);
  
  $(document).on("click",".coll_list_js li.collecion_link-list",function() {
    $(this).addClass("link_active").siblings().removeClass('link_active');
    var value_1 = $(this).attr('data-coll');
    var linkUrl = $(this).attr('data-link-url');
    $(this).closest('.coll_list_js').find('.custom_collection_list_top a').attr('href', linkUrl);
    $('.coll_list_js .collecion_list_main').each(function() {
      var value_2 = $(this).attr('collection-url');
      if( value_1 == value_2 ){
         $(this).addClass("collection_active");
        if($(document).find('.collection_active').length ){
            sortCollectionTiles('.coll_list_js .collection_active .collecion_list_main_inner');
         }
      } 
      else{
        $(this).removeClass("collection_active"); 
        $(this).parents(".coll_list_js .custom_collection_list_wrapper").find("custom_collection_list_head .collecion_link-list").removeClass("collection_active");
      }
    });
  });


  $(".continent").on("mouseover", function() {
    continentsMap();
  });
  function continentsMap() {
    if ($(".wrapper").hasClass("home")) {
        var n = "https://prospecbio.myshopify.com/cdn/shop/t/65/assets/map-"
          , t = "https://prospecbio.myshopify.com/cdn/shop/t/65/assets/map-empty.png";
          $(".continent").on("mouseover", function() {
            var t = $(this).data("continent");
            $("#emptyMap").attr("src", n + t + ".png")
        });
        $(".continent").on("mouseout", function() {
            var n = $(this).data("continent");
            $("#emptyMap").attr("src", t)
        })
    }
  }
  
  if($(window).innerWidth() <= 750) {
    $(document).on("click",".collecion_link-list_dropdown",function() {
       $('ul.collecion_link-list_main').slideToggle()
       $('.collecion_link-list_dropdown span.dropdown_arrow').addClass('dropdown_active')
    });
    $(document).on("click","ul.collecion_link-list_main",function() {
       $(this).slideToggle()
       $('.collecion_link-list_dropdown span.dropdown_arrow').removeClass('dropdown_active')
    });
    var link_list_value_first = $('.coll_list_js li.collecion_link-list:first').text();
    $('.coll_list_js .collecion_link-list_dropdown span.link_list_value').text(link_list_value_first);
    $(document).on("click","li.collecion_link-list",function() {
        var link_list_value = $(this).text();
       $('.collecion_link-list_dropdown span.link_list_value').text(link_list_value) 
     });
  }  

  $(document).on("change", "select.selecteds.slct", function() { 
      var $this = $(this);
      var variant_id = $this.find("option:selected").attr("data-value");
      if (!variant_id) return; 
      $this.closest(".coll_prdct").find(".add-to-cart-button").attr("value", variant_id);
      var $productItem = $this.closest('.coll_prd_itm');
      $productItem.find('.swym-add-to-wishlist-view-product').hide(); 
      $productItem.find('.swym-add-to-wishlist-view-product[data-varid="'+variant_id+'"]').show();
  });

  // quantity push
  $(document).on("click",".qtybox .btnqty",function() {
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    if($(this).hasClass('qtyplus')) {
      qty++;
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qtybox').find('.quantity-input').val(qty);
    var qtty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    $(this).parents(".coll_prdct").find("#quantity_itg").attr("value" , qtty);
  }); 
  
  $('.product_tab_heading_inner li').click(function(){
    var value_1 = $(this).attr('class');
    $('.product_tab_head .tab_content').each(function() {
      var value_2 = $(this).attr('class');
       if( value_1 == value_2 ){
         $(this).addClass('product_tab_active');
       }
       else{
         $(this).removeClass('product_tab_active'); 
       }
    });
      $(this).attr('active','tab_heading_active').siblings().removeAttr('active');
  });


  $(window).on("load", function() {
    footer_lazyloader();
  });

  function footer_lazyloader() {
    $("video.lazy-video source").each(function(){
        var sourceFile = $(this).attr('data-src');
        $(this).attr('src',sourceFile);
        var video = this.parentElement;
        video.load();
        video.play();
    });
  }

  $(document).on('change', '.cart_item-selected', function () {
    var $parent = $(this).closest('.coll_prdct');
    var variantId = $parent.find('option:selected').data('value');
    var mainVariantId = $parent.find('.cart_item-selected option[disabled]').data('value');
    var variantQty = $parent.find('.quantity__input').val();

    if (!variantId || !mainVariantId) {
        console.error("Variant ID or Main Variant ID is missing.");
        return;
    }

    const loader = document.querySelector('.loadr_main');
    if (loader) {
        loader.style.display = 'block';
    }

    $.ajax({
        type: "POST",
        url: '/cart/change.js',
        data: { id: mainVariantId, quantity: 0 },
        dataType: "json",
        success: function () {
            $.ajax({
                type: "POST",
                url: '/cart/add.js',
                data: { id: variantId, quantity: variantQty },
                dataType: "json",
                success: function () {
                    window.location.href = '/cart';
                },
                error: function (err) {
                    console.error("Error adding variant:", err);
                }
            });
        },
        error: function (err) {
            console.error("Error removing main variant:", err);
        }
    });
  });


  $('.order_account_tabs .tab').hide()
  $('.order_account_tabs .tab:first-child').show()
  $('.order_account_head h2:first-child').addClass('active_head')
  $('.order_account_head h2').click(function(){
      $(this).addClass('active_head')
      $(this).siblings().removeClass('active_head')
      var active_heading = $('.order_account_head h2.active_head').attr('data-id')
      $('.order_account_tabs .tab').each(function () {
        var tab = $(this).attr('id')
        if(active_heading == tab ){
          $(this).show()
        }
        else{
          $(this).hide()
        }
      })
      
    })
  

  const address_form_custom = document.getElementById('address_form_custom');
  if(address_form_custom){
    address_form_custom.addEventListener('submit', function(event) {
      event.preventDefault();
      const loader = document.querySelector('.loadr_main');
      if(loader){
          loader.style.display = 'block';
      }
      const formData = new FormData(this);
      fetch('https://prospecbio.online/account-page/account_billing_adrress.php', {
          method: 'POST',
          body: formData,
      }).then(response => response.json()).then(data => {
        let status = data.status;
        if(status == "Sucess"){
          window.location.reload();
        }
      })
    });
  }
  
  const accountdata = document.getElementById('address_form_new');
  if(accountdata){
    accountdata.addEventListener('submit', function(event) {
      event.preventDefault();
      const loader = document.querySelector('.loadr_main');
      if(loader){
          loader.style.display = 'block';
      }
      const formData = new FormData(this);
      fetch('https://prospecbio.online/account-page/account-info.php', {
          method: 'POST',
          body: formData,
      }).then(response => response.json()).then(data => {
        let status = data.status;
        if(status == "Sucess"){
          window.location.reload();
        }
      })
    });
  }

  
  const cartdatacheck = localStorage.getItem('CartClear');
  if(cartdatacheck){
    fetch(`https://prospecbio.online/prospecbio/api/cart?CartClear=${cartdatacheck}`, {
          method: 'GET',
      }).then(response => response.json()).then(data => {
        const statuscheck = data.status;
        if(statuscheck == true){
          fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            }
          }).then(response => response.json()).then(data => {
            const countitem = data.item_count;
            document.querySelector('.header_cart_count').textContent = `(${countitem})`;
            localStorage.removeItem('CartClear');
          })
        }
    })
  }

});

